var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-check"},[_c('div',{staticClass:"data-content"},[_c('div',{staticStyle:{"width":"100%","display":"flex"}},[_c('div',{staticClass:"report-content"},[_c('Table',{attrs:{"stripe":"","border":"","highlight-row":"","columns":_vm.columns,"data":_vm.changeDataList,"height":_vm.tableHeight},on:{"on-selection-change":_vm.selected},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.title))])]}},{key:"new_user_count",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.new_user_count))]),(row.new_user_count_change == 1)?_c('span',{staticStyle:{"color":"red","font-weight":"700"}},[_vm._v("↑")]):_vm._e(),(row.new_user_count_change == 2)?_c('span',{staticStyle:{"color":"lightgreen","font-weight":"700"}},[_vm._v("↓")]):_vm._e()]}},{key:"income_rmb",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.income_rmb))]),(row.income_rmb_change == 1)?_c('span',{staticStyle:{"color":"red","font-weight":"700"}},[_vm._v("↑")]):_vm._e(),(row.income_rmb_change == 2)?_c('span',{staticStyle:{"color":"lightgreen","font-weight":"700"}},[_vm._v("↓")]):_vm._e()]}},{key:"active_user_count",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.active_user_count))]),(row.active_user_count_change == 1)?_c('span',{staticStyle:{"color":"red","font-weight":"700"}},[_vm._v("↑")]):_vm._e(),(row.active_user_count_change == 2)?_c('span',{staticStyle:{"color":"lightgreen","font-weight":"700"}},[_vm._v("↓")]):_vm._e()]}},{key:"puc_d1",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.puc_d1))])]}},{key:"income_d1",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.income_d1))])]}},{key:"pay_rate1",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.pay_rate1))])]}},{key:"arpu1",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.arpu1))])]}},{key:"arppu1",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.arppu1))])]}},{key:"puc_d7",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.puc_d7))])]}},{key:"income_d7",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.income_d7))])]}},{key:"pay_rate7",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.pay_rate7))])]}},{key:"arpu7",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.arpu7))])]}},{key:"arppu7",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.arppu7))])]}}])})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }